module.exports = __webpack_public_path__ + "static/CHF-5-front-419bad8b94e163cccfcbb2787f614b2d.png";